import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"cloudy-sunny"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M2 16.5333C2 18.4479 3.61178 20 5.6 20H15.5C17.9853 20 20 18.0599 20 15.6667C20 14.0605 19.0926 12.6585 17.7445 11.91C17.0838 11.5432 16.3174 11.3333 15.5 11.3333C15.4751 11.3333 15.4502 11.3335 15.4254 11.3339C15.0716 9.30141 13.4933 7.66861 11.4459 7.16281C11.0157 7.05652 10.5647 7 10.1 7C7.11766 7 4.7 9.32812 4.7 12.2C4.7 12.5261 4.73117 12.8451 4.79079 13.1546C3.19223 13.5082 2 14.8867 2 16.5333Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M15.5004 11.3333C15.4755 11.3333 15.4506 11.3335 15.4258 11.3339C15.0719 9.30142 13.4937 7.66862 11.4463 7.16283C12.1118 5.878 13.4535 5 15.0004 5C17.2095 5 19.0004 6.79086 19.0004 9C19.0004 10.1467 18.5179 11.1807 17.7448 11.91C17.0842 11.5432 16.3177 11.3333 15.5004 11.3333Z"}},{"tag":"g","attrs":{"id":"stroke2"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M15.5009 11.3333C15.476 11.3333 15.4511 11.3335 15.4263 11.3339C15.0724 9.30142 13.4942 7.66862 11.4468 7.16283C12.1123 5.878 13.454 5 15.0009 5C17.21 5 19.0009 6.79086 19.0009 9C19.0009 10.1467 18.5184 11.1807 17.7453 11.91C17.0847 11.5432 16.3182 11.3333 15.5009 11.3333Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M10.0561 4.05168L10.0536 4.05416L10.0508 4.05136L10.0533 4.04887L10.0561 4.05168Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M15.0005 2L15.004 2V2.00396L15.0005 2.00396V2Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M19.9517 4.04886L19.9542 4.05135L19.9514 4.05415L19.9489 4.05166L19.9517 4.04886Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M22.0045 9.00003V9.00355H22.0005V9.00003H22.0045Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M2 16.5333C2 18.4479 3.61178 20 5.6 20H15.5C17.9853 20 20 18.0599 20 15.6667C20 14.0605 19.0926 12.6585 17.7445 11.91C17.0838 11.5432 16.3174 11.3333 15.5 11.3333C15.4751 11.3333 15.4502 11.3335 15.4254 11.3339C15.0716 9.30141 13.4933 7.66861 11.4459 7.16281C11.0157 7.05652 10.5647 7 10.1 7C7.11766 7 4.7 9.32812 4.7 12.2C4.7 12.5261 4.73117 12.8451 4.79079 13.1546C3.19223 13.5082 2 14.8867 2 16.5333Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const CloudySunny = Vue.extend<IconProps>({
  name: 'CloudySunnyIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'cloudy-sunny',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default CloudySunny;
